import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { PersonLayout } from '../PersonLayout';
import { type ComboboxItem } from '@mantine/core';
import { useLocation, useParams } from 'react-router-dom';
import { type Service } from '@/schemas/API/GET/service/response';

const navigationOptions: ComboboxItem[] = [
  {
    label: 'Detail služby',
    value: 'details',
  },
  {
    label: 'Přilohy',
    value: 'attachments',
  },
  {
    label: 'Historie cen',
    value: 'priceHistory',
  },
];

export const ServiceLayout = (): JSX.Element => {
  const { serviceId } = useParams<{ serviceId: string }>();
  const { data: service } = useSWR<Service>(
    `/services/${serviceId}`,
    getFetcher
  );

  return (
    <PersonLayout
      fullname={service?.name}
      onClosePath="/services"
      serviceDependentSections={[]}
      navigationOptions={navigationOptions}
      inputSection={useLocation().pathname.split('/').filter(Boolean)[1]}
    />
  );
};
